import { useMemo, useRef, useState } from 'react'

type StateAction<ARGS extends any[], R> = (...args: ARGS) => R

function createActions<S>() {
  return <MAP extends { [key: string]: StateAction<any, any> }>(mapFn: (setState: (state: S) => void, getState: () => S) => MAP) => mapFn
}

export function useStateWithActions<S, MAP extends { [key: string]: StateAction<any, any> }>(
  initialState: S | (() => S),
  actionsCreator: (setState: (state: S) => void, getState: () => S) => MAP
) {
  const [state, setState] = useState<S>(typeof initialState === 'function' ? (initialState as any)() : initialState)
  const stateRef = useRef(state)

  const boundActions = useMemo(() => {
    const subSetState = (state: S) => {
      stateRef.current = state
      setState(state)
    }
    const getState = () => stateRef.current
    return actionsCreator(subSetState, getState)
  }, [actionsCreator])

  return [state, boundActions] as const
}

useStateWithActions.createActions = createActions
